// Styles
import Styles from 'map-styles';

class Map {
  /**
   * Constructor: Map Constructor.
   */
  constructor(args = {}) {
    // Elements
    this._root    = args.root;
    this._default = { styles: Styles }; 
    this._options = Object.assign({}, this._default, args.options);

    // Create Map
    this._map = new google.maps.Map(this._root, this._options);

    // Create Marker
    this._marker = new google.maps.Marker({
      position: {
        lat: this._options.center.lat,
        lng: this._options.center.lng,
      },
      map: this._map,
      icon: {
        url: ASSETS + '/images/marker.png',
        size: new google.maps.Size(30, 30),
        scaledSize: new google.maps.Size(30, 30),
      },
    });

    // Resize
    google.maps.event.addDomListener(window, 'resize', () => {
      const center = this._map.getCenter();
      google.maps.event.trigger(this._map, 'resize');
      this._map.setCenter(center); 
    });
  }
}

export default Map;


// WEBPACK FOOTER //
// ./src/js/modules/map.js